/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': '載入中...',
	'dlg_close': '關閉',
	'dlg_ok': '確定',
	'dlg_cancel': '取消',
	'dlg_back': '回上頁',
	'dlg_done': '完成',
	'dlg_save': '儲存',

	// Slider
	'sliderRegionLabel': '滑塊控制項，使用右移鍵和左移鍵來移動滑塊處理程式',
	'sliderHandleLabel': '滑塊處理程式',
	'a11ySliderHandleLabel': '滑塊處理程式 %{sliderValue}',
	'sliderInputLabel': '值',

	// Side bar
	'sidebarAdd': '新增',
	'clearTextFilterValue': '清除',
	'missingDataSetData': '此資料集的資料無法使用。請重新整理此資料集，或聯絡管理者以取得來源的存取權。',

	// Toolbar
	'toolbarRegionLabel': '工具列',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': '字型系列',
	'fontFamilyStyle': '字型類型',
	'regularFontStyle': '標準',
	'fontSizeSelect': '字型大小',
	'fontColorSelect': '顏色',
	'fontStyle': '樣式',
	'colorPickerTitle': '選取顏色',
	'bold': '粗體',
	'italic': '斜體',
	'underline': '底線',
	'fontAlignment': '對齊方式',
	'justifyLeft': '靠左對齊',
	'justifyCenter': '置中對齊',
	'justifyRight': '靠右對齊',
	'insertOrderedList': '排序的清單',
	'insertUnorderedList': '未排序的清單',
	'fontColorPicker': '顏色選取器',
	'textWrap': '自動換行',
	'restore': '還原預設值',
	'textAutoFontSize': '自動',
	'textDefaultFontSize': '預設',
	'textItemTitle': '標題',
	'textLabelShadow': '標籤陰影',
	'textContrastLabelColor':'對比顏色',
	'toggleOn': '開啟',
	'toggleOff': '關閉',
	'contrastLabelColorInfo': '自動調整協助工具的標籤顏色。 這會置換字型顏色。',
	'labelShadowInfo':'針對協助工具給文字新增陰影。',
	'applyToAll':'將樣式套用至所有軸',

	// Top Bottom
	'topbottomNumberOfResultsLabel': '結果數 (%{lower} - %{higher})',
	'topbottomPercentLabel': '百分比 (%{lower}% - %{higher}%)',
	'topbottomSelectOption': '最前或最後選項',
	'topbottomOptionLabel': '顯示',
	'searchByLabel': '依據',
	'searchNoMatches': '找不到任何相符項',
	'topbottomRankColumnLabel': '新增排名直欄至表格',
	'topbottomNone': '無',
	'topCount': '最高計數',
	'topPercent': '最高百分比',
	'bottomCount': '最低計數',
	'bottomPercent': '最低百分比',
	'searchColumn': '尋找直欄',
	'searchColumnAriaLabel': '尋找直欄。鍵入要搜尋的直欄名稱，然後使用下移鍵尋找清單中的該直欄',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': '等級 (%{columnLabel})',
	'topbottomClearLabel': '重設',

	// Format
	'formatAuto': '自動',
	'formatConvertPercent': '將十進位轉換為百分比',
	'formatAbbreviate': '縮寫',
	'formatUseGrouping': '使用千位分隔字元',
	'dateStyle': '日期樣式',
	'dateTimeStyle': '日期/時間樣式',
	'formatMissingValueCharactersInfo': '遺漏值字元指定值遺漏時要顯示的字元。',
	'currencySymbolLabel': '貨幣符號',
	'customSymbolPlaceholder': '新增符號',
	'customSymbolLabelInfo': '指定字元以用作自訂符號。此符號會在數字和任何符號之前。',
	'numberLabel': '數字標籤',
	'numberPositionLabel': '標籤位置',
	'negativeSignPosition': '負號位置',
	'negativeSign': '負號',
	'numberLabelInfo': '指定格式化數字的標籤，並根據標籤位置放置為字首或字尾。',
	'nullValueDefault': '<預設值>',
	'nullValueContent': '（沒有值）',
	'default': '預設',
	'beginning': '開始',
	'end': '結束',
	'formatLabel': '選取格式',

	// More data indicator
	'moreDataIndicator': '在 %{threshold} 項目上，資料已被裁切。請套用過濾器以精簡顯示。',

	// Expanded View / Focus mode
	'evCollapse': '收合',
	'duplicate': '複製',
	'copyOf': '%{name} 的副本',
	'unableToDuplicateBoard': '無法複製 "%{name}"。',

	// Widget list
	'errorLoadingWidgetList': '我們無法載入物件。',

	// Custom widgets
	'customWidget': '自訂小組件',

	// Auto group
	'group': '群組',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': '髮絲',
	'textFontFamilySubClassThin': '特細',
	'textFontFamilySubClassThinItalic': '特細斜體',
	'textFontFamilySubClassExtraLight': '非常細',
	'textFontFamilySubClassExtraLightItalic': '非常細斜體',
	'textFontFamilySubClassLight': '明亮',
	'textFontFamilySubClassLightItalic': '細斜體',
	'textFontFamilySubClassRegular': '標準',
	'textFontFamilySubClassRegularItalic': '標準斜體',
	'textFontFamilySubClassItalic': '斜體',
	'textFontFamilySubClassMedium': '中',
	'textFontFamilySubClassMediumItalic': '中等斜體',
	'textFontFamilySubClassHeavy': '特粗',
	'textFontFamilySubClassHeavyItalic': '特粗斜體',
	'textFontFamilySubClassDemiBold': '半粗體',
	'textFontFamilySubClassDemiBoldItalic': '半粗斜體',
	'textFontFamilySubClassBold': '粗體',
	'textFontFamilySubClassBoldItalic': '粗斜體',
	'textFontFamilySubClassExtraBold': '非常粗',
	'textFontFamilySubClassExtraBoldItalic': '非常粗斜體',
	'textFontFamilySubClassBlack': '黑色',
	'textFontFamilySubClassBlackItalic': '特黑斜體',
	'textFontFamilySubClassStencil': '模板字體',
	// END: Remove FontFamilySubClass
});
